import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const ConfigureIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;
    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="#21006E" fillRule="nonzero" transform="translate(3 5)">
                    <path d="M18 1.9L18 3.1 8.5 3.1 8.5 1.9z"></path>
                    <path d="M2.5 1.9L2.5 3.1 0 3.1 0 1.9z"></path>
                    <path d="M8.5-.5h-6v6h6v-6zm-1 1v4h-4v-4h4z"></path>
                    <path d="M18 10.9L18 12.1 15.5 12.1 15.5 10.9z"></path>
                    <path d="M10.5 10.9L10.5 12.1 0 12.1 0 10.9z"></path>
                    <path d="M15.5 8.5h-6v6h6v-6zm-1 1v4h-4v-4h4z"></path>
                </g>
            </g>
        </SvgIcon>
    );
};
